import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'
import { dataExportsProxy } from './dataExportsProxy'

export async function executeUserDataExportsRetrieve (id: string): Promise<void> {
  dataExportsProxy.apiCall.error = null
  dataExportsProxy.apiCall.loading = true
  try {
    const response = await buildAxiosInstance().post('/api/data_exports/retrieve', { userDataExportId: String(id) })
    if (response.data.error) {
      dataExportsProxy.apiCall.error = response.data.error
      return
    }

    dataExportsProxy.currentUserDataExport = response.data.data.userDataExport
    dataExportsProxy.currentUserDataExportFiles = response.data.data.userDataExportFiles
  } catch (e) {
    if (e instanceof Error) {
      dataExportsProxy.apiCall.error = e.message
    }
  } finally {
    dataExportsProxy.apiCall.loading = false
  }
}
